<template>
    <div>
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">
                            <i class="nav-icon fas fa-user-shield"></i>
                            Medidas Protetivas <small>Monitoramento</small>
                        </h1>
                    </div>

                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <router-link to="/dashboard">
                                    <i class="nav-icon fas fa-home"></i> Home
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active">
                                <i class="nav-icon fas fa-user-shield"></i> Medidas Protetivas
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <section class="content" v-if="entity && entity.tb_user_victim">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="card card-primary card-outline">
                            <div class="card-body box-profile">
                                <div class="text-center">
                                    <img
                                        class="profile-user-img img-fluid img-circle"
                                        :src="entity.tb_user_victim.foto"
                                        alt=""
                                    >
                                </div>

                                <h3 class="profile-username text-center">
                                    {{ entity.tb_user_victim.name }}
                                </h3>

                                <p class="text-muted text-center">
                                    {{ entity.tb_user_victim.email }}
                                </p>

                                <ul class="list-group list-group-unbordered mb-3">
                                    <li class="list-group-item">
                                        <b>Telefone: </b> {{ entity.tb_user_victim.telefone }}
                                    </li>

                                    <li class="list-group-item">
                                        <b>Status: </b>
                                        <badge
                                            :value="entity.tb_user_victim.is_user_active"
                                            :options="[
                                                { value: true, label: 'Ativo', class: 'badge-success' },
                                                { value: false, label: 'Inativo', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>

                                    <li class="list-group-item">
                                        <b>Status de Emergência: </b>
                                        <badge
                                            :value="entity.tb_user_victim.emergencyStatus"
                                            :options="[
                                                { value: 0, label: 'Desativado', class: 'badge-secondary' },
                                                { value: 1, label: 'Alerta', class: 'badge-warning' },
                                                { value: 2, label: 'Pânico', class: 'badge-danger' },
                                                { value: 3, label: 'Emergência médica', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>

                                    <li class="list-group-item">
                                        <b>E-mail Validado: </b>
                                        <badge
                                            :value="entity.tb_user_victim.is_valid_email"
                                            :options="[
                                                { value: true, label: 'Sim', class: 'badge-success' },
                                                { value: false, label: 'Não', class: 'badge-danger' }
                                            ]"
                                        />
                                    </li>

                                    <li class="list-group-item">
                                        <b>Data de Cadastro:</b>
                                        <i class="fas fa-calendar-alt"></i>
                                        {{ entity.tb_user_victim.data_cadastro | formatDateTime }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-9">
                        <div class="card">
                            <div class="card-header">
                                <h3 class="card-title">
                                    <i class="fas fa-map"></i>
                                    Localização
                                    <span v-if="victimLocation">
                                        - {{ victimLocation.date | formatDateTime }}
                                    </span>
                                </h3>
                            </div>

                            <div class="card-body">
                                <div class="callout callout-success" v-if="victimLocation">
                                    <p>
                                        <strong>Vítima:</strong>
                                        <i class="far fa-map-marker-plus"></i>
                                        Latitude: <b>{{ victimLocation.latitude }}</b> -

                                        <i class="far fa-map-marker-minus"></i>
                                        Longitude: <b>{{ victimLocation.longitude }}</b> -

                                        <i class="fal fa-map-marker-exclamation"></i>
                                        Altitude: <b>{{ victimLocation.altitude }}</b> -

                                        <i class="far fa-tachometer-alt-slow"></i>
                                        Velocidade: <b>{{ victimLocation.speed }}</b>
                                    </p>
                                </div>

                                <div class="callout callout-danger" v-if="aggressorLocation">
                                    <p>
                                        <strong>Agressor:</strong>
                                        <i class="far fa-map-marker-plus"></i>
                                        Latitude: <b>{{ aggressorLocation.latitude }}</b> -

                                        <i class="far fa-map-marker-minus"></i>
                                        Longitude: <b>{{ aggressorLocation.longitude }}</b> -

                                        <i class="fal fa-map-marker-exclamation"></i>
                                        Altitude: <b>{{ aggressorLocation.altitude }}</b> -

                                        <i class="far fa-tachometer-alt-slow"></i>
                                        Velocidade: <b>{{ aggressorLocation.speed }}</b>
                                    </p>
                                </div>

                                <div
                                    v-if="hasVictimLocation || hasAggressorLocation"
                                    ref="protectiveMeasureMap"
                                    class="delivery-route-map"
                                ></div>

                                <div v-else class="alert alert-warning">
                                    Nenhuma localização disponível para exibir no mapa.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="content" v-else>
            <div class="container-fluid">
                <div class="alert alert-info">
                    Carregando informações da medida protetiva...
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ProtectiveMeasureController from "@/controllers/protective_measure.controller";

export default {
    data: function () {
        return {
            entity: {},
            entityIntervalId: null,

            map: null,
            victimMarker: null,
            aggressorMarker: null,
            victimCircle: null
        };
    },

    computed: {
        victimLocation() {
            if (!this.entity.tb_user_victim ||
                !this.entity.tb_user_victim.tb_user_location ||
                !this.entity.tb_user_victim.tb_user_location.length) {
                return null;
            }

            return this.entity.tb_user_victim.tb_user_location[0];
        },

        aggressorLocation() {
            if (!this.entity.tb_user_aggressor ||
                !this.entity.tb_user_aggressor.tb_user_location ||
                !this.entity.tb_user_aggressor.tb_user_location.length) {
                return null;
            }

            return this.entity.tb_user_aggressor.tb_user_location[0];
        },

        hasVictimLocation() {
            return this.victimLocation &&
                this.victimLocation.latitude &&
                this.victimLocation.longitude;
        },

        hasAggressorLocation() {
            return this.aggressorLocation &&
                this.aggressorLocation.latitude &&
                this.aggressorLocation.longitude;
        }
    },

    mounted() {
        const id = parseInt(this.$route.params.id, 10);

        this.loadEntity(id);

        this.entityIntervalId = setInterval(() => {
            const currentId = parseInt(this.$route.params.id, 10);
            this.loadEntity(currentId);
        }, 20000);
    },

    beforeDestroy() {
        if (this.entityIntervalId) {
            clearInterval(this.entityIntervalId);
        }

        this.removeMap();
    },

    watch: {
        "$route.params.id": {
            handler(newId) {
                const id = parseInt(newId, 10);

                this.entity = {};
                this.removeMap();
                this.loadEntity(id);
            }
        }
    },

    methods: {
        loadEntity: function (id) {
            if (!id || id === 0)
                return;

            ProtectiveMeasureController.getById(id)
            .then(response => {
                this.entity = response.data.result;

                this.$nextTick(() => {
                    this.initMap();
                });
            });
        },

        loadLeafletAssets() {
            return new Promise((resolve, reject) => {
                if (window.L) {
                    resolve();
                    return;
                }

                const cssId = "leaflet-css";
                const jsId = "leaflet-js";

                if (!document.getElementById(cssId)) {
                    const link = document.createElement("link");
                    link.id = cssId;
                    link.rel = "stylesheet";
                    link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
                    document.head.appendChild(link);
                }

                const existingScript = document.getElementById(jsId);

                if (existingScript) {
                    existingScript.addEventListener("load", resolve);
                    existingScript.addEventListener("error", reject);
                    return;
                }

                const script = document.createElement("script");
                script.id = jsId;
                script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        },

        initMap: function () {
            if (!this.$refs.protectiveMeasureMap)
                return;

            if (!this.hasVictimLocation && !this.hasAggressorLocation)
                return;

            this.loadLeafletAssets().then(() => {
                const points = [];

                const victimIcon = window.L.icon({
                    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
                    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });

                const aggressorIcon = window.L.icon({
                    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
                    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
                    iconSize: [25, 41],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41]
                });

                if (!this.map) {
                    this.map = window.L.map(this.$refs.protectiveMeasureMap);

                    window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                        maxZoom: 19,
                        attribution: "&copy; OpenStreetMap"
                    }).addTo(this.map);
                }

                if (this.hasVictimLocation) {
                    const victimLatLng = [
                        parseFloat(this.victimLocation.latitude),
                        parseFloat(this.victimLocation.longitude)
                    ];

                    points.push(victimLatLng);

                    if (!this.victimMarker) {
                        this.victimMarker = window.L.marker(victimLatLng, {
                            icon: victimIcon
                        }).addTo(this.map);
                    } else {
                        this.victimMarker.setLatLng(victimLatLng);
                        this.victimMarker.setIcon(victimIcon);
                    }

                    if (!this.victimCircle) {
                        this.victimCircle = window.L.circle(victimLatLng, {
                            radius: 2000,
                            color: "green",
                            fillColor: "green",
                            fillOpacity: 0.12,
                            weight: 2
                        }).addTo(this.map);
                    } else {
                        this.victimCircle.setLatLng(victimLatLng);
                        this.victimCircle.setRadius(2000);
                    }

                    this.victimMarker.bindPopup(
                        `
                        <div>
                            <strong style="color: green;">Vítima</strong><br>
                            ${this.entity.tb_user_victim.name}<br>
                            ${this.entity.tb_user_victim.email}<br>
                            <small>Perímetro de segurança: 2 km</small>
                        </div>
                        `
                    );
                }

                if (this.hasAggressorLocation) {
                    const aggressorLatLng = [
                        parseFloat(this.aggressorLocation.latitude),
                        parseFloat(this.aggressorLocation.longitude)
                    ];

                    points.push(aggressorLatLng);

                    if (!this.aggressorMarker) {
                        this.aggressorMarker = window.L.marker(aggressorLatLng, {
                            icon: aggressorIcon
                        }).addTo(this.map);
                    } else {
                        this.aggressorMarker.setLatLng(aggressorLatLng);
                        this.aggressorMarker.setIcon(aggressorIcon);
                    }

                    this.aggressorMarker.bindPopup(
                        `
                        <div>
                            <strong style="color: red;">Agressor</strong><br>
                            ${this.entity.tb_user_aggressor.name}<br>
                            ${this.entity.tb_user_aggressor.email}
                        </div>
                        `
                    );
                }

                if (points.length === 1) {
                    this.map.setView(points[0], 16);
                }

                if (points.length > 1) {
                    const bounds = window.L.latLngBounds(points);

                    this.map.fitBounds(bounds, {
                        padding: [40, 40]
                    });
                }

                setTimeout(() => {
                    this.map.invalidateSize();
                }, 300);
            });
        },

        removeMap: function () {
            if (this.map) {
                this.map.remove();
                this.map = null;
            }

            this.victimMarker = null;
            this.aggressorMarker = null;
            this.victimCircle = null;
        },

        back: function () {
            this.$router.push({ name: "list-user" });
        }
    }
};
</script>

<style scoped>
.delivery-route-map {
    width: 100%;
    height: 600px;
    border: 1px solid #d2d6de;
    border-radius: 4px;
}

.current-user-marker-wrapper {
    background: transparent !important;
    border: 0 !important;
}

.current-user-marker {
    position: relative;
    width: 30px;
    height: 30px;
}
</style>